var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFooterbgRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 493.47 212"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M151.83 212c81.32-46.19 171.57-90.97 232.45-102.16-19.15 30.07-60.77 75.78-85.36 102.16h104.59c59.33-69.38 81.8-113.98 61.89-150.74-14.55-26.87-45.62-36.41-92.36-28.32C269.1 50.91 100.43 149.2.58 212z"
})));
export default SvgFooterbgRight;